import { connect } from 'react-redux';
import { omit } from 'lodash/fp';
import SearchContext from '../../../constants/reservation/SearchContext';
import { getIsFetching } from '../../../redux/Reservation/selectors/today';
import { getPaginationQueryOptions } from '../../../redux/Reservation/selectors/today/pagination';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Reservation/actions/components/search';
import { clearReservationToday } from '../../../redux/Reservation/actions/today';
import { fetchReservationToday } from '../../../redux/Reservation/sagas/routines';
import ReservationSearch from '../../../components/reservations/Search';
import * as Status from '../../../constants/reservation/Status';
import StatusLabels from '../../../constants/reservation/StatusLabels';
import {
  setReservationsSearchQueryCookie,
  getReservationsSearchQueryCookie,
  getReservationsRememberFlagCookie
} from '../../../services/currentUserCookie';

const context = SearchContext.TODAY;

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(state, context);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    isFetching: getIsFetching(state),
    statusOptions: [
      { value: Status.PENDING, label: StatusLabels[Status.PENDING] },
      { value: Status.ACTIVE, label: StatusLabels[Status.ACTIVE] },
      { value: Status.CONFIRMED, label: StatusLabels[Status.CONFIRMED] },
      { value: Status.CANCELED, label: StatusLabels[Status.CANCELED] },
      { value: Status.COMPLETED, label: StatusLabels[Status.COMPLETED] }
    ]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      const queryCookie = getReservationsSearchQueryCookie(context);
      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie && queryCookie) {
        const searchQuery = omit(['order', 'limit', 'page'], queryCookie);
        dispatch(onChangeQuery({ context, query: searchQuery }));
      }
    },
    onSubmit: queryOptions => {
      dispatch(clearReservationToday());
      dispatch(fetchReservationToday(queryOptions));
      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, queryOptions);
      }
    },
    onChange: searchQuery => {
      dispatch(onChangeQuery({ context, query: searchQuery }));
    },
    onClear: (includeCookie = true) => {
      dispatch(onClearQuery({ context }));
      dispatch(clearReservationToday());
      dispatch(fetchReservationToday({}));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (includeCookie && isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, {});
      }
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationSearch);
